/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Max_Lines_HelpInputs */

const en_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The maximum lines per event before creating a new event.`)
};

const fr_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de lignes par evenement avant de creer un nouvel evenement.`)
};

const de_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die maximale Anzahl an Zeilen pro Ereignis, bevor ein neues Ereignis erstellt wird.`)
};

const it_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di righe per evento prima di creare un nuovo evento.`)
};

const ru_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество строк в одном событии перед созданием нового события.`)
};

const es_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El máximo de líneas por evento antes de crear un nuevo evento.`)
};

const zh_cn2_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新事件之前，每个事件的最大行数限制。`)
};

const ja_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントを作成する前のイベントあたりの最大行数。`)
};

const hi_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया इवेंट बनाने से पहले प्रति इवेंट अधिकतम लाइनें।`)
};

const pt_pt2_plain_text_import_max_lines_help = /** @type {(inputs: Plain_Text_Import_Max_Lines_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número máximo de linhas por evento antes de criar um novo evento.`)
};

/**
* | output |
* | --- |
* | "The maximum lines per event before creating a new event." |
*
* @param {Plain_Text_Import_Max_Lines_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_max_lines_help = /** @type {((inputs?: Plain_Text_Import_Max_Lines_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Max_Lines_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_max_lines_help(inputs)
	if (locale === "de") return de_plain_text_import_max_lines_help(inputs)
	if (locale === "it") return it_plain_text_import_max_lines_help(inputs)
	if (locale === "ru") return ru_plain_text_import_max_lines_help(inputs)
	if (locale === "es") return es_plain_text_import_max_lines_help(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_max_lines_help(inputs)
	if (locale === "ja") return ja_plain_text_import_max_lines_help(inputs)
	if (locale === "hi") return hi_plain_text_import_max_lines_help(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_max_lines_help(inputs)
	return en_plain_text_import_max_lines_help(inputs)
});